import { parseCpf } from '@brazilian-utils/brazilian-utils';
import { isPassport } from '@payments-checkout/shared/helpers/constants/document-person-type.const';
import { documentType } from '../../types/customer.types';
import { CustomerFields } from '../types/customerInformation.types';

function isBrasil(contryCode: string) {
  return contryCode === '55';
}

function formatPhoneNumber(mobilePhone: {
  country_code: string;
  number: string;
  area_code: string;
}) {
  let areaCode = mobilePhone?.area_code;

  if (isBrasil(mobilePhone?.country_code)) {
    areaCode = mobilePhone?.area_code.substr(1);
  }
  return areaCode + mobilePhone?.number || '';
}

type FormattedDataProps = {
  email: string;
  name: string;
  type: string;
  document: string;
  document_type: documentType | string | undefined;
  phones: {
    mobile_phone: {
      country_code: string;
      area_code: string;
      number: string;
    };
  };
};

function customerContactData(data: CustomerFields) {
  const countryCode =
    data.countryCode?.toString()?.replace(/[^0-9]/g, '') || '';
  const areaCode =
    data.phone
      ?.toString()
      ?.replace(/[^0-9]/g, '')
      .substr(0, 2) || '';

  return {
    email: data.email?.toString() || '',
    name: data.name?.toString() || '',
    type: 'individual',
    phones: {
      mobile_phone: {
        country_code: countryCode,
        area_code: areaCode,
        number:
          data.phone
            ?.toString()
            ?.replace(/[^0-9]/g, '')
            .substr(2) || '',
      },
    },
  }
}

function customerDataPayloadBuilder(data: CustomerFields) {
  const selectedDocumentType = data.documentType as Lowercase<documentType>;
  const contactData = customerContactData(data);

  const formattedData: FormattedDataProps = {
    document: formatDocument(
      data[selectedDocumentType] ?? '',
      selectedDocumentType
    ),
    document_type: data.documentType,
    ...contactData
  };
  return formattedData;
}

function formatDocument(
  document: string,
  selectedDocumentType: string
) {
  if (isPassport(selectedDocumentType)) {
    return document;
  }

  if (selectedDocumentType === 'cnpj') {
    return document?.replace(/[^A-Z0-9]/gi, '').toUpperCase();
  }

  return parseCpf(document ?? '');
}

export {
  customerDataPayloadBuilder,
  formatPhoneNumber
};

